var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.display && !_vm.isV2)?_c('WZOverlay',{attrs:{"params":_vm.params}}):(_vm.display && _vm.isV2)?_c('WZOverlayV2',{ref:"overlay",attrs:{"params":_vm.params_v2}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }